import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppBottomSheet } from "../Generic/AppBottomSheet";
import { AppOverlay } from "../Generic/AppOverlay";

interface Props {
  isOpen: boolean;
  error?: string;
  onRequestClose: () => void;
}

const ErrorBottomSheet = (props: Props) => {
  const isOpen = props.error !== undefined;

  return (
    <AppOverlay>
      <AppBottomSheet
        isOpen={isOpen}
        color="warning"
        title={translate(STRINGS.OOPS)}
        onRequestClose={props.onRequestClose}
        rounded={true}
      >
        <p style={{ textAlign: "center" }}>{props.error}</p>
      </AppBottomSheet>
    </AppOverlay>
  );
};

export default React.memo(ErrorBottomSheet);
